<template>
  <div>
    <wc-dialog
    title='Route Quick View'
    :showDialog='showDialog'
    hideCancel
    saveText='Close'
    @save="$emit('cancel')"
    width='325'
    >
      <template v-slot:fullWidth>
        <v-virtual-scroll
          height='350'
          item-height='56'
          :items='wos'
        >
          <template v-slot='{ item }'>
            <v-list-item :key='item.id' three-lines>
              <v-list-item-content>
                <v-list-item-title>{{ item.project_name }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.project_site_address }}</v-list-item-subtitle>
                <v-divider></v-divider>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
// Opens a dialog window to quickly look at all the WOs in a route
import scheduleAPI from '../api/schedule'
import miscServices from '@/services/misc'

export default {
  name: 'route-quick-view',
  props: {
    route: {
      required: true
    },
    showDialog: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    wos: []
  }),
  watch: {
    showDialog () {
      this.getWOs()
    }
  },
  methods: {
    async getWOs () {
      this.isLoading = true
      this.wos = await scheduleAPI.getRouteWOs(this.route.id)
      this.wos = miscServices.sortLinkedList(this.wos)
      this.isLoading = false
    }
  }
}
</script>
